import qs from 'qs';
import axios from 'axios';
import _ from 'underscore';
import client from './rest/AdminClient';
import AdminServerActionCreators from '../actions/AdminServerActionCreators';
import { getBearerGrantTypeAuthHeaders } from '../helpers/auth_helpers';

const _getStatus = (id, query, shipment_type) => {
  const shorthaulQuery = {
    select:
      '_id authorized first_name last_name _type email name phone company_name account_name optimized_name geo carrier coords jobs equipment_class last_check_in',
    populate: [
      {
        path: 'carrier',
        select:
          'name authorized enterprise preferred_carrier _type email phone is_broker',
      },
      {
        path: 'jobs',
        select: 'picked_up',
      },
    ],
  };

  const drayageQuery = {
    select:
      '_id authorized first_name last_name _type email name phone company_name markets last_login_session preferred_carrier',
    populate: [
      {
        path: 'carrier',
        select: 'is_broker',
      },
      {
        path: 'markets',
      },
    ],
  };

  const baseQuery = shipment_type === 'drayage' ? drayageQuery : shorthaulQuery;
  const queryString = qs.stringify(_.extend(baseQuery, query));

  return client({
    method: 'GET',
    path: `/admin/marketplace/${id}/status?${queryString}`,
  });
};

export const getStatus = async (id, query, shipment_type) => {
  return _getStatus(id, query, shipment_type).then(
    (response) => {
      return response.entity.results;
    },
    (response) => {
      throw new Error(response.entity.error);
    },
  );
};

export const getCarrierOffersV2 = (carrier, filters = {}, options = {}) => {
  const query = _.extend({}, filters);
  const { cancelToken, ...queryOptions } = options;
  const queryString = qs.stringify({
    carrier,
    ...query,
    _: new Date().getTime(),
    ...queryOptions,
  });

  const axiosOptions = {
    method: 'get',
    url: `${API_HOST}/api/v2/marketplace/offers?${queryString}`,
    headers: {
      'Content-Type': 'application/json',
      Authorization: getBearerGrantTypeAuthHeaders(),
    },
  };
  if (cancelToken) {
    axiosOptions.cancelToken = cancelToken;
  }

  return axios(axiosOptions);
};

const _getCarrierOffers = (id) => {
  return client({
    method: 'GET',
    path: `/api/marketplace/${id}/offers`,
  });
};

const _giveDriverOffer = (offerId, userId, isResend = false) => {
  return client({
    method: 'POST',
    path: `/admin/marketplace/${offerId}/give?resend=${isResend}`,
    entity: JSON.stringify({ userId }),
  });
};

const _giveCarrierOffer = (offerId, carrierId, isResend, automated) => {
  return client({
    method: 'POST',
    path: `/api/marketplace/${carrierId}/offers/${offerId}?resend=${isResend}&automated=${automated}`,
  });
};

export const giveDriverOffer = (driverId, offerId, isResend) => {
  return _giveDriverOffer(driverId, offerId, isResend).then(
    (response) => {
      return response.entity;
    },
    (response) => {
      return response.entity;
    },
  );
};

const offers = [
  {
    id: 1,
    estimated_arrival: '2021-06-01T07:00:00.000Z',
    last_cut_date: '2021-07-01T07:00:00.000Z',
    arrival_date: '2021-07-02T07:00:00.000Z',
    discharge_date: '2021-06-12T07:00:00.000Z',
    last_free_date: '2021-07-12T07:00:00.000Z',
    empty_return_date: '2021-07-09T07:00:00.000Z',
    outgated_date: '2021-07-08T07:00:00.000Z',
    deliver_after: '2021-04-06T07:00:00.000Z',
    deliver_by: '2021-04-07T06:59:59.999Z',
    pickup_after: '2021-04-06T07:00:00.000Z',
    pickup_by: '2021-04-07T06:59:59.999Z',
    origin: [
      {
        address: '1234 Wilshire Blvd, Los Angeles, CA 90017, USA',
        street: '1234 Wilshire Blvd',
        zipcode: '90017',
        city: 'Westlake',
        state: 'CA',
        lat: 34.0532066,
        lng: -118.2660468,
        location_timezone: 'America/Los_Angeles',
        market: {
          timezone: 'America/Los_Angeles',
        },
      },
    ],
    destination: [
      {
        address: '4500 Wilshire Blvd, Los Angeles, CA 90010, USA',
        city: 'Central LA',
        state: 'CA',
        lat: 34.0615532,
        lng: -118.3277944,
        location_timezone: 'America/Los_Angeles',
        market: {
          timezone: 'America/Los_Angeles',
        },
      },
    ],
    stops: [
      {
        sequence: 1,
        action: 'pickup',
        empty: false,
        window_start: '2021-04-07T08:00:00.000Z',
        window_end: '2021-04-07T10:00:00.999Z',
        equipments: [
          {
            _type: 'ISO Dry',
            _equipmentSize: 40,
          },
        ],
        location: [
          {
            name: 'APM',
            street: '1234 Wilshire Blvd',
            zipcode: '90017',
            address: '1234 Wilshire Blvd, Los Angeles, CA 90017, USA',
            city: 'Westlake',
            state: 'CA',
            lat: 34.0532066,
            lng: -118.2660468,
            location_timezone: 'America/Los_Angeles',
            market: {
              timezone: 'America/Los_Angeles',
            },
          },
        ],
      },
      {
        sequence: 2,
        action: 'deliver',
        empty: false,
        window_start: '2021-04-06T07:00:00.000Z',
        window_end: '2021-04-07T06:59:59.999Z',
        equipments: [
          {
            _type: 'ISO Dry',
            _equipmentSize: 40,
          },
        ],
        location: [
          {
            name: 'ACME Warehouse',
            street: '4500 Wilshire Blvd',
            zipcode: '90010',
            address: '4500 Wilshire Blvd, Los Angeles, CA 90010, USA',
            city: 'Central LA',
            state: 'CA',
            lat: 34.0615532,
            lng: -118.3277944,
            location_timezone: 'America/Los_Angeles',
            market: {
              timezone: 'America/Los_Angeles',
            },
          },
        ],
      },
    ],
    weight: 12400,
    distance: 10200,
    distance_in_miles: 47.3,
    rate_per_mile: 17.97,
    cost: 850,
    order_service_type: 'drop',
    full_truckload: true,
    equipment_type: ['STRAIGHT_TRUCK', 'POWER_ONLY'],
    loads: [
      {
        height: 60,
        length: 48,
        quantity: 1,
        spaces: 1,
        stackable: false,
        type: 'pallets',
        weight: 333,
        width: 40,
      },
    ],
    shipment_type: 'shorthaul',
    created_at: '2021-04-05T23:36:23.783Z',
  },
  {
    id: 2,
    last_free_date: '2021-06-04T07:00:00.000Z',
    hazmat_description: 'Very dangerous load',
    origin: [
      {
        address: '12345 W Magnolia Blvd, Valley Village, CA 91607, USA',
        city: 'Valley Village',
        state: 'CA',
        lat: 34.1652123,
        lng: -118.4023443,
      },
    ],
    destination: [
      {
        address: '4000 S Figueroa St, Los Angeles, CA 90037, USA',
        city: 'South Los Angeles',
        state: 'CA',
        lat: 34.0106655,
        lng: -118.2824139,
      },
    ],
    stops: [
      {
        sequence: 1,
        action: 'pickup',
        empty: false,
        window_start: '2021-04-06T07:00:00.000Z',
        window_end: '2021-04-07T06:59:59.999Z',
        equipments: [
          {
            _type: 'ISO Dry',
            _equipmentSize: 40,
          },
        ],
        location: [
          {
            street: '1234 Wilshire Blvd',
            zipcode: '90017',
            address: '1234 Wilshire Blvd, Los Angeles, CA 90017, USA',
            city: 'Westlake',
            state: 'CA',
            lat: 34.0532066,
            lng: -118.2660468,
            location_timezone: 'America/Los_Angeles',
            market: {
              timezone: 'America/Los_Angeles',
            },
          },
        ],
      },
      {
        sequence: 2,
        action: 'deliver',
        empty: false,
        window_start: '2021-04-06T07:00:00.000Z',
        window_end: '2021-04-07T06:59:59.999Z',
        equipments: [
          {
            _type: 'ISO Dry',
            _equipmentSize: 40,
          },
        ],
        location: [
          {
            street: '4500 Wilshire Blvd',
            zipcode: '90010',
            address: '4500 Wilshire Blvd, Los Angeles, CA 90010, USA',
            city: 'Central LA',
            state: 'CA',
            lat: 34.0615532,
            lng: -118.3277944,
            location_timezone: 'America/Los_Angeles',
            market: {
              timezone: 'America/Los_Angeles',
            },
          },
        ],
      },
    ],
    weight: 17890,
    distance: 10200,
    distance_in_miles: 134.7,
    rate_per_mile: 10.39,
    cost: 1400,
    order_service_type: 'drop',
    shipment_type: 'drayage',
    created_at: '2021-04-05T23:36:23.783Z',
  },
  {
    id: 3,
    estimated_arrival: '2021-06-01T07:00:00.000Z',
    last_cut_date: '2021-07-02T07:00:00.000Z',
    arrival_date: '2021-07-03T07:00:00.000Z',
    discharge_date: '2021-06-12T07:00:00.000Z',
    last_free_date: '2021-07-12T07:00:00.000Z',
    empty_return_date: '2021-07-09T07:00:00.000Z',
    outgated_date: '2021-07-08T07:00:00.000Z',
    origin: [
      {
        address: '1234 Wilshire Blvd, Los Angeles, CA 90017, USA',
        city: 'Westlake',
        state: 'CA',
        lat: 34.0532066,
        lng: -118.2660468,
      },
    ],
    destination: [
      {
        address: '4500 Wilshire Blvd, Los Angeles, CA 90010, USA',
        city: 'Central LA',
        state: 'CA',
        lat: 34.0615532,
        lng: -118.3277944,
      },
    ],
    stops: [
      {
        sequence: 1,
        action: 'pickup',
        empty: false,
        window_start: '2021-04-06T07:00:00.000Z',
        window_end: '2021-04-07T06:59:59.999Z',
        equipments: [
          {
            _type: 'ISO Dry',
            _equipmentSize: 40,
          },
        ],
        location: [
          {
            street: '1234 Wilshire Blvd',
            zipcode: '90017',
            address: '1234 Wilshire Blvd, Los Angeles, CA 90017, USA',
            city: 'Westlake',
            state: 'CA',
            lat: 34.0532066,
            lng: -118.2660468,
            location_timezone: 'America/Los_Angeles',
            market: {
              timezone: 'America/Los_Angeles',
            },
          },
        ],
      },
      {
        sequence: 2,
        action: 'deliver',
        empty: false,
        window_start: '2021-04-06T07:00:00.000Z',
        window_end: '2021-04-07T06:59:59.999Z',
        equipments: [
          {
            _type: 'ISO Dry',
            _equipmentSize: 40,
          },
        ],
        location: [
          {
            street: '4500 Wilshire Blvd',
            zipcode: '90010',
            address: '4500 Wilshire Blvd, Los Angeles, CA 90010, USA',
            city: 'Central LA',
            state: 'CA',
            lat: 34.0615532,
            lng: -118.3277944,
            location_timezone: 'America/Los_Angeles',
            market: {
              timezone: 'America/Los_Angeles',
            },
          },
        ],
      },
    ],
    weight: 27520,
    distance: 10200,
    distance_in_miles: 54.0,
    rate_per_mile: 10.39,
    cost: 1115,
    order_service_type: 'drop',
    shipment_type: 'drayage',
    created_at: '2021-04-05T23:36:23.783Z',
  },
  {
    id: 4,
    last_cut_date: '2021-07-03T07:00:00.000Z',
    arrival_date: '2021-07-03T07:00:00.000Z',
    discharge_date: '2021-06-10T07:00:00.000Z',
    last_free_date: '2021-07-12T07:00:00.000Z',
    empty_return_date: '2021-07-09T07:00:00.000Z',
    outgated_date: '2021-07-08T07:00:00.000Z',
    origin: [
      {
        address: '1234 Wilshire Blvd, Los Angeles, CA 90017, USA',
        city: 'Westlake',
        state: 'CA',
        lat: 34.0532066,
        lng: -118.2660468,
      },
    ],
    destination: [
      {
        address: '4500 Wilshire Blvd, Los Angeles, CA 90010, USA',
        city: 'Central LA',
        state: 'CA',
        lat: 34.0615532,
        lng: -118.3277944,
      },
    ],
    weight: 3000,
    stops: [
      {
        sequence: 1,
        action: 'pickup',
        empty: false,
        window_start: '2021-04-06T07:00:00.000Z',
        window_end: '2021-04-07T06:59:59.999Z',
        equipments: [
          {
            _type: 'ISO Dry',
            _equipmentSize: 40,
          },
        ],
        location: [
          {
            street: '1234 Wilshire Blvd',
            zipcode: '90017',
            address: '1234 Wilshire Blvd, Los Angeles, CA 90017, USA',
            city: 'Westlake',
            state: 'CA',
            lat: 34.0532066,
            lng: -118.2660468,
            location_timezone: 'America/Los_Angeles',
            market: {
              timezone: 'America/Los_Angeles',
            },
          },
        ],
      },
      {
        sequence: 2,
        action: 'deliver',
        empty: false,
        window_start: '2021-04-06T07:00:00.000Z',
        window_end: '2021-04-07T06:59:59.999Z',
        equipments: [
          {
            _type: 'ISO Dry',
            _equipmentSize: 40,
          },
        ],
        location: [
          {
            street: '4500 Wilshire Blvd',
            zipcode: '90010',
            address: '4500 Wilshire Blvd, Los Angeles, CA 90010, USA',
            city: 'Central LA',
            state: 'CA',
            lat: 34.0615532,
            lng: -118.3277944,
            location_timezone: 'America/Los_Angeles',
            market: {
              timezone: 'America/Los_Angeles',
            },
          },
        ],
      },
    ],
    distance: 10200,
    distance_in_miles: 6,
    rate_per_mile: 10.39,
    cost: 1400,
    order_service_type: 'drop',
    shipment_type: 'drayage',
    created_at: '2021-04-05T23:36:23.783Z',
  },
  {
    id: 5,
    estimated_arrival: '2021-06-01T07:00:00.000Z',
    arrival_date: '2021-07-05T07:00:00.000Z',
    discharge_date: '2021-06-17T07:00:00.000Z',
    last_free_date: '2021-07-18T07:00:00.000Z',
    empty_return_date: '2021-07-09T07:00:00.000Z',
    outgated_date: '2021-07-08T07:00:00.000Z',
    origin: [
      {
        address: '1234 Wilshire Blvd, Los Angeles, CA 90017, USA',
        city: 'Westlake',
        state: 'CA',
        lat: 34.0532066,
        lng: -118.2660468,
      },
    ],
    destination: [
      {
        address: '4500 Wilshire Blvd, Los Angeles, CA 90010, USA',
        city: 'Central LA',
        state: 'CA',
        lat: 34.0615532,
        lng: -118.3277944,
      },
    ],
    stops: [
      {
        sequence: 1,
        action: 'pickup',
        empty: false,
        window_start: '2021-04-06T07:00:00.000Z',
        window_end: '2021-04-07T06:59:59.999Z',
        equipments: [
          {
            _type: 'ISO Dry',
            _equipmentSize: 40,
          },
        ],
        location: [
          {
            street: '1234 Wilshire Blvd',
            zipcode: '90017',
            address: '1234 Wilshire Blvd, Los Angeles, CA 90017, USA',
            city: 'Westlake',
            state: 'CA',
            lat: 34.0532066,
            lng: -118.2660468,
            location_timezone: 'America/Los_Angeles',
            market: {
              timezone: 'America/Los_Angeles',
            },
          },
        ],
      },
      {
        sequence: 2,
        action: 'deliver',
        empty: false,
        window_start: '2021-04-06T07:00:00.000Z',
        window_end: '2021-04-07T06:59:59.999Z',
        equipments: [
          {
            _type: 'ISO Dry',
            _equipmentSize: 40,
          },
        ],
        location: [
          {
            street: '4500 Wilshire Blvd',
            zipcode: '90010',
            address: '4500 Wilshire Blvd, Los Angeles, CA 90010, USA',
            city: 'Central LA',
            state: 'CA',
            lat: 34.0615532,
            lng: -118.3277944,
            location_timezone: 'America/Los_Angeles',
            market: {
              timezone: 'America/Los_Angeles',
            },
          },
        ],
      },
    ],
    weight: 4000,
    distance: 10200,
    distance_in_miles: 6,
    rate_per_mile: 10.39,
    cost: 1400,
    order_service_type: 'drop',
    shipment_type: 'drayage',
    created_at: '2021-04-05T23:36:23.783Z',
  },
  {
    id: 6,
    estimated_arrival: '2021-06-01T07:00:00.000Z',
    arrival_date: '2021-07-09T07:00:00.000Z',
    discharge_date: '2021-06-18T07:00:00.000Z',
    last_free_date: '2021-07-19T07:00:00.000Z',
    empty_return_date: '2021-07-09T07:00:00.000Z',
    outgated_date: '2021-07-08T07:00:00.000Z',
    origin: [
      {
        address: '1234 Wilshire Blvd, Los Angeles, CA 90017, USA',
        city: 'Westlake',
        state: 'CA',
        lat: 34.0532066,
        lng: -118.2660468,
      },
    ],
    destination: [
      {
        address: '4500 Wilshire Blvd, Los Angeles, CA 90010, USA',
        city: 'Central LA',
        state: 'CA',
        lat: 34.0615532,
        lng: -118.3277944,
      },
    ],
    stops: [
      {
        sequence: 1,
        action: 'pickup',
        empty: false,
        window_start: '2021-04-06T07:00:00.000Z',
        window_end: '2021-04-07T06:59:59.999Z',
        equipments: [
          {
            _type: 'ISO Dry',
            _equipmentSize: 40,
          },
        ],
        location: [
          {
            street: '1234 Wilshire Blvd',
            zipcode: '90017',
            address: '1234 Wilshire Blvd, Los Angeles, CA 90017, USA',
            city: 'Westlake',
            state: 'CA',
            lat: 34.0532066,
            lng: -118.2660468,
            location_timezone: 'America/Los_Angeles',
            market: {
              timezone: 'America/Los_Angeles',
            },
          },
        ],
      },
      {
        sequence: 2,
        action: 'deliver',
        empty: false,
        window_start: '2021-04-06T07:00:00.000Z',
        window_end: '2021-04-07T06:59:59.999Z',
        equipments: [
          {
            _type: 'ISO Dry',
            _equipmentSize: 40,
          },
        ],
        location: [
          {
            street: '4500 Wilshire Blvd',
            zipcode: '90010',
            address: '4500 Wilshire Blvd, Los Angeles, CA 90010, USA',
            city: 'Central LA',
            state: 'CA',
            lat: 34.0615532,
            lng: -118.3277944,
            location_timezone: 'America/Los_Angeles',
            market: {
              timezone: 'America/Los_Angeles',
            },
          },
        ],
      },
    ],
    weight: 5000,
    distance: 10200,
    distance_in_miles: 6,
    rate_per_mile: 10.39,
    cost: 1400,
    order_service_type: 'drop',
    shipment_type: 'drayage',
    created_at: '2021-04-05T23:36:23.783Z',
  },
  {
    id: 7,
    estimated_arrival: '2021-06-01T07:00:00.000Z',
    last_cut_date: '2021-07-10T07:00:00.000Z',
    arrival_date: '2021-07-09T07:00:00.000Z',
    discharge_date: '2021-06-16T07:00:00.000Z',
    last_free_date: '2021-07-12T07:00:00.000Z',
    empty_return_date: '2021-07-09T07:00:00.000Z',
    outgated_date: '2021-07-08T07:00:00.000Z',
    origin: [
      {
        address: '1234 Wilshire Blvd, Los Angeles, CA 90017, USA',
        city: 'Westlake',
        state: 'CA',
        lat: 34.0532066,
        lng: -118.2660468,
      },
    ],
    destination: [
      {
        address: '4500 Wilshire Blvd, Los Angeles, CA 90010, USA',
        city: 'Central LA',
        state: 'CA',
        lat: 34.0615532,
        lng: -118.3277944,
      },
    ],
    stops: [
      {
        sequence: 1,
        action: 'pickup',
        empty: false,
        window_start: '2021-04-06T07:00:00.000Z',
        window_end: '2021-04-07T06:59:59.999Z',
        equipments: [
          {
            _type: 'ISO Dry',
            _equipmentSize: 40,
          },
        ],
        location: [
          {
            street: '1234 Wilshire Blvd',
            zipcode: '90017',
            address: '1234 Wilshire Blvd, Los Angeles, CA 90017, USA',
            city: 'Westlake',
            state: 'CA',
            lat: 34.0532066,
            lng: -118.2660468,
            location_timezone: 'America/Los_Angeles',
            market: {
              timezone: 'America/Los_Angeles',
            },
          },
        ],
      },
      {
        sequence: 2,
        action: 'deliver',
        empty: false,
        window_start: '2021-04-06T07:00:00.000Z',
        window_end: '2021-04-07T06:59:59.999Z',
        equipments: [
          {
            _type: 'ISO Dry',
            _equipmentSize: 40,
          },
        ],
        location: [
          {
            street: '4500 Wilshire Blvd',
            zipcode: '90010',
            address: '4500 Wilshire Blvd, Los Angeles, CA 90010, USA',
            city: 'Central LA',
            state: 'CA',
            lat: 34.0615532,
            lng: -118.3277944,
            location_timezone: 'America/Los_Angeles',
            market: {
              timezone: 'America/Los_Angeles',
            },
          },
        ],
      },
    ],
    weight: 6000,
    distance: 10200,
    distance_in_miles: 6,
    rate_per_mile: 10.39,
    cost: 1400,
    order_service_type: 'drop',
    shipment_type: 'drayage',
    created_at: '2021-04-05T23:36:23.783Z',
  },
  {
    id: 8,
    last_cut_date: '2021-07-15T07:00:00.000Z',
    arrival_date: '2021-07-09T07:00:00.000Z',
    discharge_date: '2021-06-16T07:00:00.000Z',
    last_free_date: '2021-07-12T07:00:00.000Z',
    empty_return_date: '2021-07-09T07:00:00.000Z',
    outgated_date: '2021-07-08T07:00:00.000Z',
    origin: [
      {
        address: '1234 Wilshire Blvd, Los Angeles, CA 90017, USA',
        city: 'Westlake',
        state: 'CA',
        lat: 34.0532066,
        lng: -118.2660468,
      },
    ],
    destination: [
      {
        address: '4500 Wilshire Blvd, Los Angeles, CA 90010, USA',
        city: 'Central LA',
        state: 'CA',
        lat: 34.0615532,
        lng: -118.3277944,
      },
    ],
    stops: [
      {
        sequence: 1,
        action: 'pickup',
        empty: false,
        window_start: '2021-04-06T07:00:00.000Z',
        window_end: '2021-04-07T06:59:59.999Z',
        equipments: [
          {
            _type: 'ISO Dry',
            _equipmentSize: 40,
          },
        ],
        location: [
          {
            street: '1234 Wilshire Blvd',
            zipcode: '90017',
            address: '1234 Wilshire Blvd, Los Angeles, CA 90017, USA',
            city: 'Westlake',
            state: 'CA',
            lat: 34.0532066,
            lng: -118.2660468,
            location_timezone: 'America/Los_Angeles',
            market: {
              timezone: 'America/Los_Angeles',
            },
          },
        ],
      },
      {
        sequence: 2,
        action: 'deliver',
        empty: false,
        window_start: '2021-04-06T07:00:00.000Z',
        window_end: '2021-04-07T06:59:59.999Z',
        equipments: [
          {
            _type: 'ISO Dry',
            _equipmentSize: 40,
          },
        ],
        location: [
          {
            street: '4500 Wilshire Blvd',
            zipcode: '90010',
            address: '4500 Wilshire Blvd, Los Angeles, CA 90010, USA',
            city: 'Central LA',
            state: 'CA',
            lat: 34.0615532,
            lng: -118.3277944,
            location_timezone: 'America/Los_Angeles',
            market: {
              timezone: 'America/Los_Angeles',
            },
          },
        ],
      },
    ],
    weight: 12400,
    distance: 10200,
    distance_in_miles: 6,
    rate_per_mile: 10.39,
    cost: 1400,
    order_service_type: 'drop',
    shipment_type: 'drayage',
    created_at: '2021-04-05T23:36:23.783Z',
  },
  {
    id: 9,
    estimated_arrival: '2021-06-01T07:00:00.000Z',
    last_cut_date: '2021-07-16T07:00:00.000Z',
    arrival_date: '2021-07-10T07:00:00.000Z',
    discharge_date: '2021-06-17T07:00:00.000Z',
    last_free_date: '2021-07-12T07:00:00.000Z',
    empty_return_date: '2021-07-09T07:00:00.000Z',
    outgated_date: '2021-07-08T07:00:00.000Z',
    origin: [
      {
        address: '1234 Wilshire Blvd, Los Angeles, CA 90017, USA',
        city: 'Westlake',
        state: 'CA',
        lat: 34.0532066,
        lng: -118.2660468,
      },
    ],
    destination: [
      {
        address: '4500 Wilshire Blvd, Los Angeles, CA 90010, USA',
        city: 'Central LA',
        state: 'CA',
        lat: 34.0615532,
        lng: -118.3277944,
      },
    ],
    stops: [
      {
        sequence: 1,
        action: 'pickup',
        empty: false,
        window_start: '2021-04-06T07:00:00.000Z',
        window_end: '2021-04-07T06:59:59.999Z',
        equipments: [
          {
            _type: 'ISO Dry',
            _equipmentSize: 40,
          },
        ],
        location: [
          {
            street: '1234 Wilshire Blvd',
            zipcode: '90017',
            address: '1234 Wilshire Blvd, Los Angeles, CA 90017, USA',
            city: 'Westlake',
            state: 'CA',
            lat: 34.0532066,
            lng: -118.2660468,
            location_timezone: 'America/Los_Angeles',
            market: {
              timezone: 'America/Los_Angeles',
            },
          },
        ],
      },
      {
        sequence: 2,
        action: 'deliver',
        empty: false,
        window_start: '2021-04-06T07:00:00.000Z',
        window_end: '2021-04-07T06:59:59.999Z',
        equipments: [
          {
            _type: 'ISO Dry',
            _equipmentSize: 40,
          },
        ],
        location: [
          {
            street: '4500 Wilshire Blvd',
            zipcode: '90010',
            address: '4500 Wilshire Blvd, Los Angeles, CA 90010, USA',
            city: 'Central LA',
            state: 'CA',
            lat: 34.0615532,
            lng: -118.3277944,
            location_timezone: 'America/Los_Angeles',
            market: {
              timezone: 'America/Los_Angeles',
            },
          },
        ],
      },
    ],
    weight: 12400,
    distance: 10200,
    distance_in_miles: 45,
    rate_per_mile: 10.39,
    cost: 1400,
    order_service_type: 'drop',
    shipment_type: 'drayage',
    created_at: '2021-04-05T23:36:23.783Z',
  },
  {
    id: 10,
    estimated_arrival: '2021-06-01T07:00:00.000Z',
    last_cut_date: '2021-07-16T07:00:00.000Z',
    arrival_date: '2021-07-10T07:00:00.000Z',
    discharge_date: '2021-06-17T07:00:00.000Z',
    last_free_date: '2021-07-12T07:00:00.000Z',
    empty_return_date: '2021-07-09T07:00:00.000Z',
    outgated_date: '2021-07-08T07:00:00.000Z',
    origin: [
      {
        address: '1234 Wilshire Blvd, Los Angeles, CA 90017, USA',
        city: 'Westlake',
        state: 'CA',
        lat: 34.0532066,
        lng: -118.2660468,
      },
    ],
    destination: [
      {
        address: '4500 Wilshire Blvd, Los Angeles, CA 90010, USA',
        city: 'Central LA',
        state: 'CA',
        lat: 34.0615532,
        lng: -118.3277944,
      },
    ],
    stops: [
      {
        sequence: 1,
        action: 'pickup',
        empty: false,
        window_start: '2021-04-06T07:00:00.000Z',
        window_end: '2021-04-07T06:59:59.999Z',
        equipments: [
          {
            _type: 'ISO Dry',
            _equipmentSize: 40,
          },
        ],
        location: [
          {
            street: '1234 Wilshire Blvd',
            zipcode: '90017',
            address: '1234 Wilshire Blvd, Los Angeles, CA 90017, USA',
            city: 'Westlake',
            state: 'CA',
            lat: 34.0532066,
            lng: -118.2660468,
            location_timezone: 'America/Los_Angeles',
            market: {
              timezone: 'America/Los_Angeles',
            },
          },
        ],
      },
      {
        sequence: 2,
        action: 'deliver',
        empty: false,
        window_start: '2021-04-06T07:00:00.000Z',
        window_end: '2021-04-07T06:59:59.999Z',
        equipments: [
          {
            _type: 'ISO Dry',
            _equipmentSize: 40,
          },
        ],
        location: [
          {
            street: '4500 Wilshire Blvd',
            zipcode: '90010',
            address: '4500 Wilshire Blvd, Los Angeles, CA 90010, USA',
            city: 'Central LA',
            state: 'CA',
            lat: 34.0615532,
            lng: -118.3277944,
            location_timezone: 'America/Los_Angeles',
            market: {
              timezone: 'America/Los_Angeles',
            },
          },
        ],
      },
    ],
    distance: 10200,
    distance_in_miles: 6,
    rate_per_mile: 10.39,
    cost: 1400,
    order_service_type: 'drop',
    shipment_type: 'drayage',
    created_at: '2021-04-05T23:36:23.783Z',
  },
  {
    id: 11,
    estimated_arrival: '2021-06-01T07:00:00.000Z',
    last_cut_date: '2021-07-17T07:00:00.000Z',
    arrival_date: '2021-07-14T07:00:00.000Z',
    discharge_date: '2021-06-25T07:00:00.000Z',
    last_free_date: '2021-07-19T07:00:00.000Z',
    empty_return_date: '2021-07-09T07:00:00.000Z',
    outgated_date: '2021-07-08T07:00:00.000Z',
    origin: [
      {
        address: '1234 Wilshire Blvd, Los Angeles, CA 90017, USA',
        city: 'Westlake',
        state: 'CA',
        lat: 34.0532066,
        lng: -118.2660468,
      },
    ],
    destination: [
      {
        address: '4500 Wilshire Blvd, Los Angeles, CA 90010, USA',
        city: 'Central LA',
        state: 'CA',
        lat: 34.0615532,
        lng: -118.3277944,
      },
    ],
    weight: 5000,
    stops: [
      {
        sequence: 1,
        action: 'pickup',
        empty: false,
        window_start: '2021-04-06T07:00:00.000Z',
        window_end: '2021-04-07T06:59:59.999Z',
        equipments: [
          {
            _type: 'ISO Dry',
            _equipmentSize: 40,
          },
        ],
        location: [
          {
            street: '1234 Wilshire Blvd',
            zipcode: '90017',
            address: '1234 Wilshire Blvd, Los Angeles, CA 90017, USA',
            city: 'Westlake',
            state: 'CA',
            lat: 34.0532066,
            lng: -118.2660468,
            location_timezone: 'America/Los_Angeles',
            market: {
              timezone: 'America/Los_Angeles',
            },
          },
        ],
      },
      {
        sequence: 2,
        action: 'deliver',
        empty: false,
        window_start: '2021-04-06T07:00:00.000Z',
        window_end: '2021-04-07T06:59:59.999Z',
        equipments: [
          {
            _type: 'ISO Dry',
            _equipmentSize: 40,
          },
        ],
        location: [
          {
            street: '4500 Wilshire Blvd',
            zipcode: '90010',
            address: '4500 Wilshire Blvd, Los Angeles, CA 90010, USA',
            city: 'Central LA',
            state: 'CA',
            lat: 34.0615532,
            lng: -118.3277944,
            location_timezone: 'America/Los_Angeles',
            market: {
              timezone: 'America/Los_Angeles',
            },
          },
        ],
      },
    ],
    distance: 10200,
    distance_in_miles: 6,
    rate_per_mile: 10.39,
    cost: 1400,
    order_service_type: 'drop',
    shipment_type: 'drayage',
    created_at: '2021-04-05T23:36:23.783Z',
  },
];

export const getDrayageOffers = async () => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve({
        entity: {
          pages: 26,
          total: 255,
          offers,
        },
      });
    }, 1000);
  });
};

export const getCarrierOffers = (id) => {
  return _getCarrierOffers(id).then(
    (response) => {
      return response.entity.offers;
    },
    (error) => {
      throw error;
    },
  );
};

export const giveCarrierOffer = (
  offerId,
  carrierId,
  isResend,
  automated = false,
) => {
  return _giveCarrierOffer(offerId, carrierId, isResend, automated).then(
    (response) => {
      AdminServerActionCreators.receiveDrayageOfferSuccess(
        response.entity.offers,
      );
      return response.entity.offers;
    },
    (response) => {
      AdminServerActionCreators.receiveDrayageOfferFail(response);
      throw new Error(response.entity.error);
    },
  );
};

export const asyncGiveCarrierOffer = async (
  offerId,
  carrierId,
  isResend,
  automated = false,
) => {
  return _giveCarrierOffer(offerId, carrierId, isResend, automated);
};
